<template>
  <v-container fluid class="pt-0">
    <v-row class="pt-0">
      <v-col cols="12">
        <v-row justify="space-between">
          <v-col cols="12" sm="5">
            <div class="primary--text text-h6 text-md-h5 font-weight-medium">
              {{ $t('title_cap_product') }}
            </div>
          </v-col>
        </v-row>
        <v-row justify="space-between" align="center" class="pt-0">
          <v-col cols="12" sm="7" class="pt-0">
            <v-row align="center">
              <v-col cols="12" sm="12" md="5" class="mx-sm-auto">
                <CassNewProduct :locale="locale" />
              </v-col>
              <v-col cols="12" sm="12" md="6" class="mx-sm-auto">
                <CassNewSubProduct :locale="locale" />
              </v-col>
            </v-row>
            <v-row v-if="$store.state.account.role === 'owner'" align="center">
              <v-col cols="12" sm="12" md="5" class="mx-sm-auto">
                <CassNewCategory :locale="locale" />
              </v-col>
              <v-col cols="12" sm="12" md="6" class="mx-sm-auto">
                <CassNewMenu :locale="locale" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="3" class="pt-0">
            <v-select
              v-model="filterBranch"
              :items="branches"
              placeholder="All Branches"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8">
        <v-row no-gutters>
          <!--          <v-col cols="12" md="12">-->
          <!--            <v-card>-->
          <!--              <v-card-title>-->
          <!--                <span class="headline primary&#45;&#45;text font-weight-regular">-->
          <!--                  {{$t('title_cap_promo')}}-->
          <!--                </span>-->
          <!--                <v-spacer></v-spacer>-->
          <!--                <span class="subtitle-2 font-weight-regular">-->
          <!--                  {{$t('cap_promo_count', { value: 2 })}}-->
          <!--                </span>-->
          <!--              </v-card-title>-->
          <!--              <v-card-subtitle>-->
          <!--                <v-list-item class="pl-0">-->
          <!--                  <v-list-item-icon>-->
          <!--                    <v-icon class="primary&#45;&#45;text" dark>mdi-information-variant</v-icon>-->
          <!--                  </v-list-item-icon>-->
          <!--                  <v-list-item-subtitle>-->
          <!--                    {{$t('title_promo_policy')}}-->
          <!--                  </v-list-item-subtitle>-->
          <!--                </v-list-item>-->
          <!--              </v-card-subtitle>-->
          <!--              <v-container class="pt-0">-->
          <!--                <v-card flat v-for="(promo, i) in promotionSets" :key="i">-->
          <!--                  <v-list-item>-->
          <!--                    <v-list-item-avatar size="80" color="grey" tile></v-list-item-avatar>-->
          <!--                    <v-list-item-content>-->
          <!--                      <v-list-item-title>{{promo.title}}</v-list-item-title>-->
          <!--                      <v-list-item-subtitle>{{promo.desc}}</v-list-item-subtitle>-->
          <!--                      <v-list-item-subtitle>{{promo.rate}}</v-list-item-subtitle>-->
          <!--                    </v-list-item-content>-->
          <!--                    <v-list-item-action>-->
          <!--                      <v-card-text class="pt-0">{{promo.deadline}}</v-card-text>-->
          <!--                      <v-btn text>-->
          <!--                        <v-icon>mdi-delete-forever</v-icon>-->
          <!--                      </v-btn>-->
          <!--                    </v-list-item-action>-->
          <!--                  </v-list-item>-->
          <!--                </v-card>-->
          <!--              </v-container>-->
          <!--            </v-card>-->
          <!--          </v-col>-->
          <v-col cols="12" md="12">
            <v-card>
              <v-card-title>
                <span class="headline primary--text font-weight-regular">
                  {{ $t('title_cap_prod') }}
                </span>
                <v-spacer></v-spacer>
                <span class="subtitle-2 font-weight-regular">
                  {{
                    $t('cap_prod_count', {
                      value: $store.getters['product/productCount']
                    })
                  }}
                </span>
              </v-card-title>
              <v-card-subtitle>
                <v-list-item class="pl-0">
                  <v-list-item-icon>
                    <v-icon class="primary--text"
                      >mdi-information-variant</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-subtitle>
                    {{ $t('title_prod_policy') }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-card-subtitle>
              <v-container class="pt-0">
                <v-col cols="8">
                  <v-text-field
                    v-model="filterName"
                    :label="$t('input_txt_search')"
                    single-line
                  ></v-text-field>
                </v-col>
                <v-card
                  v-for="product in $store.getters[
                    'product/productAfterFilter'
                  ]"
                  :key="product.documentId"
                  outlined
                >
                  <v-list-item>
                    <v-list-item-avatar size="80" color="grey" tile>
                      <v-img :src="product.image"> </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ formatMulti(product.name) }}
                      </v-list-item-title>
                      {{ formatMulti(product.displayTime) }}
                      <v-row>
                        <v-col class="py-0 body-2" cols="12">
                          <div>
                            {{ formatCategories(product.category).join(',') }}
                          </div>
                        </v-col>
                        <v-col
                          v-for="(price, i) in product.pricing"
                          :key="i"
                          class="py-0 body-2"
                          cols="12"
                        >
                          <div>
                            {{ formatMulti(price.measureUnit) }}: $
                            {{ price.price }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action>
                      <CassEditProduct
                        :document-id="product.documentId"
                        :locale="locale"
                      ></CassEditProduct>
                      <v-btn text @click="onProductDelete(product)">
                        <v-icon>mdi-delete-forever</v-icon>
                      </v-btn>
                      <v-switch
                        v-model="product.active"
                        @change="
                          onProductActive(product.documentId, product.active)
                        "
                      ></v-switch>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" md="12" class="mt-5">
            <v-card>
              <v-card-title>
                <span class="headline primary--text font-weight-regular">
                  {{ $t('title_cap_sub_prod') }}
                </span>
                <v-spacer></v-spacer>
                <span class="subtitle-2 font-weight-regular">
                  {{
                    $t('cap_sub_prod_count', {
                      value: $store.getters['subProduct/subProductCount']
                    })
                  }}
                </span>
              </v-card-title>
              <v-card-subtitle>
                <v-list-item class="pl-0">
                  <v-list-item-icon>
                    <v-icon class="primary--text"
                      >mdi-information-variant</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-subtitle>
                    {{ $t('title_sub_prod_policy') }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-card-subtitle>
              <v-container class="pt-0">
                <v-col cols="8">
                  <v-text-field
                    v-model="filterSubProductName"
                    :label="$t('input_txt_search')"
                    single-line
                  ></v-text-field>
                </v-col>
                <v-card
                  v-for="subProduct in $store.getters[
                    'subProduct/subProductAfterFilter'
                  ]"
                  :key="subProduct.documentId"
                  outlined
                >
                  <v-list-item>
                    <v-list-item-avatar size="80" color="grey" tile>
                      <v-img :src="subProduct.image"> </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ formatMulti(subProduct.name) }}
                      </v-list-item-title>
                      <v-row>
                        <v-col class="py-0 body-2" cols="12">
                          <div>{{ subProductName(subProduct.productId) }}</div>
                        </v-col>
                        <v-col
                          v-for="(price, i) in subProduct.pricing"
                          :key="i"
                          class="py-0 body-2"
                          cols="12"
                        >
                          <div>
                            {{ formatMulti(price.measureUnit) }}: $
                            {{ price.price }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action>
                      <CassEditSubProduct
                        :document-id="subProduct.documentId"
                        :locale="locale"
                      ></CassEditSubProduct>
                      <v-btn text @click="onSubProductDelete(subProduct)">
                        <v-icon>mdi-delete-forever</v-icon>
                      </v-btn>
                      <v-switch
                        v-model="subProduct.active"
                        @click.native="
                          onSubProductActive(
                            subProduct.documentId,
                            subProduct.active
                          )
                        "
                      ></v-switch>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title class="mx-auto primary--text">{{
            $t('title_quick_info')
          }}</v-card-title>
          <v-card-text class="pb-0">
            <v-avatar size="34"
              ><img
                src="https://img.icons8.com/color/48/000000/facebook-messenger.png"
                alt="facebookIcon"
            /></v-avatar>
            <span>
              {{ $store.state.tenant.name }}
            </span>
          </v-card-text>
          <v-card-text class="pb-0 pt-3">
            <v-icon>mdi-city</v-icon>
            <span
              class="pl-1"
              v-html="
                $t('cap_txt_bus_branch', {
                  value: $store.getters['tenant/activeBranches'].length
                })
              "
            >
            </span>
          </v-card-text>
          <!--          <v-card-text class="pb-0">-->
          <!--            <v-icon>mdi-table</v-icon>-->
          <!--            <span class="pl-1">Promotions Sets</span>-->
          <!--          </v-card-text>-->
          <v-card-text class="pb-0">
            <v-icon>mdi-dropbox</v-icon>
            <span class="pl-1">
              {{
                $t('cap_prod_count', {
                  value: $store.getters['product/productCount']
                })
              }}
            </span>
          </v-card-text>
          <v-card-text>
            <v-icon>mdi-dropbox</v-icon>
            <span class="pl-1">
              {{
                $t('cap_sub_prod_count', {
                  value: $store.getters['subProduct/subProductCount']
                })
              }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-overlay
        :value="
          $store.getters['tenant/activeBranches'].length <= 0
            ? (overlay = true)
            : (overlay = false)
        "
        :opacity="opacity"
      >
        <router-link to="/setting"
          ><h4>{{ $t('cap_required_setup') }}</h4></router-link
        >
      </v-overlay>
    </v-row>
  </v-container>
</template>

<script>
import CassNewProduct from '../components/dialogs/CassNewProduct'
import CassNewSubProduct from '../components/dialogs/CassNewSubProduct'
import CassEditProduct from '../components/dialogs/CassEditProduct'
import CassEditSubProduct from '../components/dialogs/CassEditSubProduct'
import CassNewCategory from '@/components/dialogs/CassNewCategory'
import CassNewMenu from '@/components/dialogs/CassNewMenu'
export default {
  components: {
    CassNewMenu,
    CassNewCategory,
    CassNewProduct,
    CassNewSubProduct,
    CassEditProduct,
    CassEditSubProduct
  },
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      filterBranch: '',
      filterName: '',
      filterSubProductName: '',
      overlay: false,
      opacity: 1
    }
  },
  computed: {
    branches() {
      const branch = JSON.parse(
        JSON.stringify(this.$store.getters['tenant/branches'])
      )
      branch.unshift('All')
      return branch
    },
    promotionSets() {
      return [
        {
          title: '50% OFF for Tropic Seafood Pizza',
          desc: 'Tropic Pizza for all Size',
          rate: '50% OFF',
          deadline: '28/03/2020'
        },
        {
          title: '50% OFF for Tropic Seafood Pizza',
          desc: 'Tropic Pizza for all Size',
          rate: '50% OFF',
          deadline: '28/03/2020'
        },
        {
          title: '50% OFF for Tropic Seafood Pizza',
          desc: 'Tropic Pizza for all Size',
          rate: '50% OFF',
          deadline: '28/03/2020'
        }
      ]
    }
  },
  watch: {
    filterBranch(v) {
      if (v === 'All') {
        v = ''
      }
      this.$store.commit('product/filterBranch', v)
    },
    filterName(v) {
      this.$store.commit('product/filterLocale', this.locale)
      this.$store.commit('product/filterName', v)
    },
    filterSubProductName(v) {
      this.$store.commit('subProduct/filterLocale', this.locale)
      this.$store.commit('subProduct/filterName', v)
    }
  },
  methods: {
    onProductDelete(product) {
      if (
        confirm(
          this.$t('cap_msg_delete_pro', {
            name: this.formatMulti(product.name)
          })
        )
      ) {
        this.$store.dispatch('product/deleteProduct', product)
      }
    },
    onSubProductDelete(subProduct) {
      if (
        confirm(
          this.$t('cap_msg_delete_pro', {
            name: this.formatMulti(subProduct.name)
          })
        )
      ) {
        this.$store.dispatch('subProduct/deleteSubProduct', subProduct)
      }
    },
    subProductName(productId) {
      const productName = []
      productId.forEach((id) => {
        this.$store.state.product.products.forEach((product) => {
          if (product.documentId === id) {
            if (typeof product.name === 'object') {
              if (
                Object.prototype.hasOwnProperty.call(product.name, this.locale)
              ) {
                productName.push(product.name[this.locale])
              } else {
                productName.push(product.name.en)
              }
            } else {
              productName.push(product.name)
            }
          }
        })
      })
      return productName.join(', ')
    },
    formatMulti(value) {
      if (typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, this.locale)) {
          return value[this.locale]
        } else {
          return value.en
        }
      } else {
        return value
      }
    },
    formatCategories(categories) {
      const t = []
      categories.forEach((category) => {
        this.$store.state.tenant.categories.forEach((x) => {
          if (typeof x === 'object') {
            if (x.en === category) {
              if (Object.prototype.hasOwnProperty.call(x, this.locale)) {
                t.push(x[this.locale])
              } else {
                t.push(x.en)
              }
            }
          } else if (x === category) {
            return t.push(x)
          }
        })
      })
      return t
    },
    onProductActive(documentId, flag) {
      const showProduct = {
        documentId,
        active: flag
      }
      this.$store
        .dispatch('product/showProducts', showProduct)
        .then(() => {
          // eslint-disable-next-line
          console.log('success')
        })
        .catch(() => {
          // eslint-disable-next-line
          console.log('error')
        })
    },
    onSubProductActive(documentId, flag) {
      const showSubProduct = {
        documentId,
        active: flag
      }
      this.$store
        .dispatch('subProduct/onSubProductActive', showSubProduct)
        .then(() => {
          // eslint-disable-next-line
          console.log('success')
        })
        .catch(() => {
          // eslint-disable-next-line
          console.log('error')
        })
    }
  }
}
</script>
